import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { FormioUtils } from "angular-formio/dist";
import { IPostMessageEventTarget, PostMessageBridgeFactory } from "@tekool/ngx-post-message-angular-9";
import { ToastrService } from "ngx-toastr";
import { Components as FormioComponents, Formio } from "formiojs";
import { environment } from "../../../environments/environment";
import { ClassificationType } from "../../models/classification-type";
import { MyContentComponent } from "../../models/formio/mycontent-component"; // #FormioUpgradeRemove
import { MyValidationBot } from "../../models/formio/myvalidation-bot";
import { SelectWithAddComponent } from "../../models/formio/select-with-add";
import { Registration } from "../../models/registration";
import { GuideFormControllerService } from "../../services/form-controller/guide-form-controller.service";
import { ApplicantFormControllerService } from "../../services/form-controller/applicant-form-controller.service";
import { FormControllerService } from "../../services/form-controller/form-controller.service";
import { FormioControllerService } from "../../services/form-controller/formio-controller.service";
import { SendFileFormControllerService } from "../../services/form-controller/sendfile-form-controller.service";
import { FormDeterminantControllerService } from "../../services/form-controller/form-determinant-controller.service";
import { PaymentFormControllerService } from "../../services/form-controller/payment-form-controller.service";
import { RegistrationControllerService } from "../../services/registration-controller/registration-controller.service";
import { RoleControllerService } from "../../services/role-controller/role-controller.service";
import { ComponentBehaviourService } from "../../services/component-behaviour/component-behaviour-service";
import { ActivatedRoute } from "@angular/router";
import { Store } from "../../services/store.service";
import { BaseError } from "../pages/base-error";
import FormUtils from "../utils/form-utils.component";
import { DataMappingHelpers } from "../../models/data-mapping-helpers";
import * as alert from "./components/alert.json";
import * as receipt from "./components/receipt-number.json";
import * as status from "./components/status.json";
import * as myList from "./components/my-list.json";
import * as printTemplateButton from "./components/print-template-button.json";
import * as qrcode from "./components/qr-code.json";
import * as registrationSelection from "./components/registration-selection.json";
import * as serviceForms from "./components/service-forms.json";
import * as swearComponent from "./components/swear-component.json";
import * as formBuilder from "./conf/form-builder.json";
import * as tabApi from "./conf/tab-api.json";
import * as tabConditional from "./conf/tab-conditional.json";
import * as tabDataButton from "./conf/tab-data-button.json";
import * as tabDataCheckbox from "./conf/tab-data-checkbox.json";
import * as tabDataDateTime from "./conf/tab-data-datetime.json";
import * as tabDataSelect from "./conf/tab-data-select.json";
import * as tabDataContent from "./conf/tab-data-content.json";
import * as tabDataFile from "./conf/tab-data-file.json";
import * as tabDataHidden from "./conf/tab-data-hidden.json";
import * as tabDataTextField from "./conf/tab-data-textfield.json";
import * as tabDataLeafletMap from "./conf/tab-data-leafletmap.json";
import * as tabFileFile from "./conf/tab-file-file.json";
import * as tabData from "./conf/tab-data.json";
import * as tabDeterminant from "./conf/tab-determinant.json";
import * as tabDateDateTime from "./conf/tab-date-datetime.json";
import * as tabFormula from "./conf/tab-formula.json";
import * as tabTimeDateTime from "./conf/tab-time-datetime.json";
import * as tabGeneralButton from "./conf/tab-general-button.json";
import * as tabGeneralDropdown from "./conf/tab-general-dropdown.json";
import * as tabGeneralLeafletMap from "./conf/tab-general-leafletmap.json";
import * as tabGeneralInput from "./conf/tab-general-input.json";
import * as tabGeneralCheckbox from "./conf/tab-general-checkbox.json";
import * as tabGeneralSelect from "./conf/tab-general-select.json";
import * as tabGeneralSelectBoxes from "./conf/tab-general-selectboxes.json";
import * as tabGeneralRadio from "./conf/tab-general-radio.json";
import * as tabGeneralColumns from "./conf/tab-general-columns.json";
import * as tabGeneralContent from "./conf/tab-general-content.json";
import * as tabGeneralCurrency from "./conf/tab-general-currency.json";
import * as tabGeneralEditGrid from "./conf/tab-general-editgrid.json";
import * as tabGeneralDataGrid from "./conf/tab-general-datagrid.json";
import * as tabGeneralDateTime from "./conf/tab-general-datetime.json";
import * as tabGeneralFieldset from "./conf/tab-general-fieldset.json";
import * as tabGeneralMyContent from "./conf/tab-general-mycontent.json";
import * as tabGeneralNumber from "./conf/tab-general-number.json";
import * as tabGeneralPanel from "./conf/tab-general-panel.json";
import * as tabGeneralTable from "./conf/tab-general-table.json";
import * as tabGeneralTabs from "./conf/tab-general-tabs.json";
import * as tabGeneralTextfield from "./conf/tab-general-textfield.json";
import * as tabGeneralFile from "./conf/tab-general-file.json";
import * as tabGeneralEmail from "./conf/tab-general-email.json";
import * as tabGeneralUrl from "./conf/tab-general-url.json";
import * as tabGeneralTextarea from "./conf/tab-general-textarea.json";
import * as tabGeneralAddress from "./conf/tab-general-address.json";
import * as tabGeneralDay from "./conf/tab-general-day.json";
import * as tabGeneral from "./conf/tab-general.json";
import * as tabLayout from "./conf/tab-layout.json";
import * as tabLogic from "./conf/tab-logic.json";
import * as tabRegistration from "./conf/tab-registration.json";
import * as tabTemplate from "./conf/tab-template.json";
import * as tabTriggers from "./conf/tab-triggers.json";
import * as tabTabs from "./conf/tab-tabs.json";
import * as tabTranslate from "./conf/tab-translate.json";
import * as tabValidationButton from "./conf/tab-validation-button.json";
import * as tabValidationLeafletMap from "./conf/tab-validation-leafletmap.json";
import * as tabValidationCheckbox from "./conf/tab-validation-checkbox.json";
import * as tabValidationCurrency from "./conf/tab-validation-currency.json";
import * as tabValidationDateTime from "./conf/tab-validation-datetime.json";
import * as tabValidationEditGrid from "./conf/tab-validation-editgrid.json";
import * as tabValidationNumber from "./conf/tab-validation-number.json";
import * as tabValidationRadio from "./conf/tab-validation-radio.json";
import * as tabDataRadio from "./conf/tab-data-radio.json";
import * as tabDataNumber from "./conf/tab-data-number.json";
import * as tabDataEditGrid from "./conf/tab-data-editgrid.json";
import * as tabDataDataGrid from "./conf/tab-data-datagrid.json";
import * as tabValidationSelect from "./conf/tab-validation-select.json";
import * as tabValidationTextfield from "./conf/tab-validation-textfield.json";
import * as tabValidationDay from "./conf/tab-validation-day.json";
import * as tabValidation from "./conf/tab-validation.json";
import * as tabValidationTextarea from "./conf/tab-validation-textarea.json";
import * as tabValidationTime from "./conf/tab-validation-time.json";
import * as tabValidationEmail from "./conf/tab-validation-email.json";
import * as tabValidationUrl from "./conf/tab-validation-url.json";
import * as tabValidationAddress from "./conf/tab-validation-address.json";
import * as tabValidationFile from "./conf/tab-validation-file.json";
import * as tabValidationResource from "./conf/tab-validation-resource.json";
import * as tabValidationDatagrid from "./conf/tab-validation-datagrid.json";
import * as tabValidationContent from "./conf/tab-validation-content.json";
import * as tabValidationMyContent from "./conf/tab-validation-mycontent.json";
import * as tabCopyEditgrid from "./conf/tab-copy-editgrid.json";
import * as tabCopyDataGrid from "./conf/tab-copy-datagrid.json";
import * as tabProviderAddress from "./conf/tab-provider-address.json";
import * as barcode from "./components/barcode.json";
import { SelectWithAddCustomClassComponent } from "../../models/formio/select-with-add-custom-class";
import { DocumentFormControllerService } from "../../services/form-controller/document-form-controller.service";
import FormioDigitalSignatureComponent from "formio-digital-signature-component";
import FormioNestedHtmlElement from "formio-nested-html-element";
import FormioLeafletMap from "formio-leaflet-map";
import FormioDropdown from "formio-dropdown";
import { AuthService } from "../../services/auth/auth-service";
import * as _ from "lodash";
import { ServiceControllerService } from "../../services/service-controller/service-controller.service";
import { Service } from "../../models/service";
import { TagControllerService } from "../../services/form-controller/tag-controller.service";
import {
  DefaultLangChangeEvent,
  LangChangeEvent,
  TranslationChangeEvent,
} from "@ngx-translate/core";
import * as CKEDITOR from "../../../assets/libs/ckeditor5";
import { IPostMessageBridge } from "@tekool/ngx-post-message-angular-9/src/IPostMessageBridge";
import {
  DocumentRequirementControllerService,
} from "../../services/requirement-controller/document-requirement-controller.service";
import { FormDeterminant } from "../../models/form-determinant";
import { DocumentResultControllerService } from "../../services/result-controller/document-result-controller.service";
import { SidenavComponent } from "../sidenav/sidenav.component";
import { DeterminantControllerService } from "../../services/registration-controller/determinant-controller.service";
import { FormioDeterminantBuilderComponent } from "../formio-determinant-builder/formio-determinant-builder.component";
import { HttpErrorResponse } from "@angular/common/http";
import {
  PreviewTranslationsControllerService
} from "../../services/preview-translations-controller/preview-translations-controller.service";
import { TranslationType } from "../../models/translation-type";
import Helpers from "../../utils/helpers";
import { RecoverOrphanConfig } from "../../models/recover-orphan-config";
// @ts-ignore
window.CKEDITOR = CKEDITOR;

@Component({
  selector: "my-formio",
  templateUrl: "./my-formio.component.html",
  providers: [FormioControllerService, RegistrationControllerService,
    FormControllerService, RoleControllerService, SendFileFormControllerService,
    FormDeterminantControllerService, GuideFormControllerService,
    ApplicantFormControllerService, DocumentFormControllerService, PaymentFormControllerService,
    TagControllerService, ComponentBehaviourService,
  ],
})
export class MyFormioComponent extends BaseError implements OnInit, OnChanges, OnDestroy {
  private restheartUrl: string = environment.RESTHEART_URL.slice(0, -1);
  private baseUrl: string = environment.BASE_URL.slice(0, -1);
  @Input() public serviceId: string;
  @Input() public fileLinkableWithRequirement: boolean = false;
  @Input() public fileLinkableWithResult: boolean = false;
  @Input() public pasteWithTransformationEnabled: boolean = false;
  @Input() public pasteWithTransformationIntoCertificate: boolean = false;
  @Input() public roleId: string;
  @Input() public formName: string;
  @Input() public formType: string;
  @Input() public formSchema: any = { components: [] };
  @Input() public copyFromFormSchema: any = { components: [] };
  @Input() public focusCompKey?: string;
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Output() public saveFormSchema = new EventEmitter();
  @ViewChild("copyFromDialog")
  private copyFromDialog: ElementRef;
  @ViewChild("mainFormBuilder") public mainFormBuilder: any;
  public options: any = JSON.parse(JSON.stringify(formBuilder.default));
  public optionsForCopy = JSON.parse(JSON.stringify(formBuilder.default));
  public determinantUrl: string;
  public genericDeterminantUrl: string;
  public relatedDeterminantUrl: string;
  public determinantTriggersUrl: string;
  public editGridValidationUrl: string;
  public triggersUrl: string;
  public formulaUrl: string;
  public tabTabsUrl: string;
  public tabTranslateUrl: string;
  public dynamicValidationUrl: string;
  public blacklistValidationUrl: string;
  public requiremntsLoaded = false;
  public requiremntsLoading = false;
  public treasuryPanelLoaded = true;
  public treasuryPanelLoading = false;
  public paymentsTableLoaded = false;
  public paymentsTableLoading = false;
  public paymentsProvidersLoaded = false;
  public paymentsProvidersLoading = false;
  public myApplicationsLoaded = false;
  public myApplicationsLoading = false;
  public triggerRefresh = new EventEmitter(); // event goes to formio
  public showFormulaBuilder = true;
  public isCopyFromOpen = false;
  public copyFromFormTitle = "";
  public roleForms: any = {};
  private tranlsationData = {};
  public form = { GLOBALS: { currencyFormat: "USD" }, userfullname: "Micky Mouse", enableRowGroups: true };
  public fieldsComponents: any[] = [];
  private borderSize: number = 12;
  private m_pos: number;
  public needsSaving = false;
  public translationsLoaded = false;
  public changedRegistrations = false;
  public rolesLoaded = false;
  private formioInstance: any;
  private service: Service;
  public debugErrors: RecoverOrphanConfig[] = [];
  public builderReady: boolean = false;
  public moustaches: any[] = [
    "listing-value",
    "company-name",
    "rejection-reasons",
    "uploaded-documents",
    "requested-registrations",
    "userid",
    "username",
    // "userfullname",
    "applicantusername",
    "applicantuserid",
    "applicantfullname",
    "applicant-email",
    "applicant-phone",
    "starterEmail",
  ];

  public allFormsFields: any[] = [];
  public duplicatedFields: any[] = [];

  private messageBridge: IPostMessageBridge;
  private formioDialogContent: HTMLElement;
  private resizeOverlay?: HTMLDivElement;
  private resizeRaf?: number;
  private pendingWidth?: number;
  private readonly minDrawerWidth: number = 360;
  public debugMode: boolean = false;

  constructor(private formioController: FormioControllerService,
    private formController: FormControllerService,
    private route: ActivatedRoute,
    private determinantService: DeterminantControllerService,
    private guideFormControllerService: GuideFormControllerService,
    private applicantFormControllerService: ApplicantFormControllerService,
    private documentFormControllerService: DocumentFormControllerService,
    private paymentFormControllerService: PaymentFormControllerService,
    private sendFileFormControllerService: SendFileFormControllerService,
    private formDeterminantControllerService: FormDeterminantControllerService,
    private registrationService: RegistrationControllerService,
    private roleController: RoleControllerService,
    private formControllerService: FormControllerService,
    private authService: AuthService,
    private componentBehaviourService: ComponentBehaviourService,
    @Inject(PostMessageBridgeFactory) private bridgeFactory: PostMessageBridgeFactory,
    public translate: TranslateService,
    public store: Store,
    private serviceControllerService: ServiceControllerService,
    public tagControllerService: TagControllerService,
    private documentRequirementControllerService: DocumentRequirementControllerService,
    private documentResultControllerService: DocumentResultControllerService,
    private previewTranslationsControllerService: PreviewTranslationsControllerService,
    toastr: ToastrService) {
    super(toastr);
    this.translate.onLangChange.subscribe((params) => this.languageSelected(params));
    this.translate.onDefaultLangChange.subscribe((params) => {
      this.translationsPresent(params);
    });
    this.resize = this.resize.bind(this);
    this.mouseup = this.mouseup.bind(this);
    this.mousedown = this.mousedown.bind(this);
    this.triggerSave = _.debounce(this.triggerSave.bind(this), 500);
    Formio.setApiUrl(this.baseUrl);
    const currentWindow: IPostMessageEventTarget = window;
    // The main usage scenario
    this.messageBridge = bridgeFactory.makeInstance()
      .setEnableLogging(true)
      .connect(currentWindow, undefined, window.location.origin)
      .makeBridge("FormBuilder")
      .makeBridge("FormulaBuilder")
      .addListener("FormBuilder", (messageString: any) => {
        const message = JSON.parse(messageString);
        // send message to formiojs core
        if (message.event === "receiveCurrentComponent") {
          this.triggerRefresh.emit({
            form: "receiveCurrentComponent",
          });
        } else if (message.event === "saveProcessing") {
          if (Array.isArray(message.deletedComponentKeys) && message.deletedComponentKeys.length > 0) {
            message.deletedComponentKeys.forEach((key) => {
              this.deleteComponentActions(this.findComponent(this.formSchema, key));
            });
          }
          document.querySelectorAll(".formio-dialog-content button[data-event=\"save-component\"]").forEach((e) => {
            if (message.state) {
              e.setAttribute("disabled", "disabled");
            } else {
              e.removeAttribute("disabled");
            }
          });
        } else if (message.changes && Object.keys(message.changes).length > 0) {
          this.triggerRefresh.emit({
            form: "relationChange",
            value: {
              count: message.count, changes: message.changes,
            },
            submission: message.submission,
          });
        } else if (message.hasOwnProperty("copyValueFromDeterminant")) {
          this.triggerRefresh.emit({
            form: "copyValueFromDeterminant",
            value: message.copyValueFromDeterminant,
          });
        } else if (message.hasOwnProperty("dynamicValidations")) {
          this.triggerRefresh.emit({
            form: "dynamicValidations",
            value: message.dynamicValidations,
          });
        } else {
          this.triggerRefresh.emit({
            form: "form",
            value: message.conditional,
          });
        }
      })
      .addListener("FormulaBuilder", (messageString: any) => {
        const message = JSON.parse(messageString);
        // send message to formiojs core
        if (message.jsonLogic && message.jsonLogic.json && message.jsonLogic.json.length > 0) {
          this.triggerRefresh.emit({
            form: "formula",
            value: message.jsonLogic.json[0],
          });
        }
      });

    Formio.registerComponent("mycontent", MyContentComponent); // shall be removed after formio upgrade in DS #FormioUpgradeRemove
    Formio.registerComponent("myvalidationbot", MyValidationBot); // must not be visible in toolbar
    Formio.registerComponent("selectwithadd", SelectWithAddComponent); // must not be visible in toolbar
    Formio.registerComponent("selectwithaddcustomcomponent", SelectWithAddCustomClassComponent); // must not be visible in toolbar
  }

  public translationsPresent(params) {
    this.languageSelected(params);
    this.getOptionsForCopy();
    this.addCustomComponents();
  }

  public languageSelected(params: LangChangeEvent | DefaultLangChangeEvent): void {
    this.translationsLoaded = true;
    this.tranlsationData[params.lang] = params.translations;
    this.resetOptions();
    this.getOptions();
  }

  public resetOptions(): void {
    this.requiremntsLoaded = false;
    this.paymentsTableLoaded = false;
    this.paymentsProvidersLoaded = false;
  }

  public formioCKBlur(ev: any) {
    if (!this.formioInstance || !ev.detail || !ev.detail.component || ev.detail.oldHtml != null && ev.detail.component.component.html === ev.detail.oldHtml) {
      return;
    }
    this.formSchema = this.formioInstance.schema;
    // CKEditor now handles target="_blank" via link config in form-builder.json
    // Just sync the HTML to formSchema without transformation
    FormioUtils.eachComponent(this.formSchema.components, (component: any) => {
      if (component.key === ev.detail.component.component.key) {
        component.html = ev.detail.component.component.html;
      }
    });
    // @ts-ignore
    this.previewTranslationsControllerService.replaceOrCreateTranslation(this.serviceId, {
      oldFieldId: ev.detail.oldHtml,
      fieldId: ev.detail.component.component.html,
      fieldName: ev.detail.component.component.html,
      location: "FORM_FIELD",
      type: TranslationType.DS
    }).subscribe();
    this.saveForm();
  }

  public formioEditComponent(ev: any) {
    if (!ev.detail) {
      return;
    }
    this.updateTabNames(ev);
  }

  public formioDeleteComponent(ev: any) {
    if (!ev.detail || !ev.detail.component || !ev.detail.component.key) {
      return;
    }
    // we do not want to delete related field actions / formulas / determinants
    // in case component does not originate from current form
    if (ev.detail.component.key.toLowerCase().startsWith(this.formName.replace(" ", "").toLowerCase())) {
      this.deleteComponentActions(ev.detail.component);
    }
  }

  public openFormForCopy(ev: any) {
    if (!ev.detail) {
      return;
    }
    if (!ev.detail.key) {
      return;
    }
    this.getOptionsForCopy();

    switch (ev.detail.key.slice(0, 4) === "role" ? "role" : ev.detail.key) {
      case "guide":
        this.guideFormControllerService.getGuideForm(this.serviceId, true).subscribe(
          (data) => {
            this.copyFromFormSchema = (data ? data.formSchema : this.copyFromFormSchema);
            this.isCopyFromOpen = true;
            this.copyFromFormTitle = "builder.guide";
          },
        );
        break;
      case "applicantform":
        this.applicantFormControllerService.getApplicantForm(this.serviceId, true).subscribe(
          (data) => {
            this.copyFromFormSchema = (data ? data.formSchema : this.copyFromFormSchema);
            this.isCopyFromOpen = true;
            this.copyFromFormTitle = "builder.applicantForm";
          },
        );
        break;
      case "document-form":
        this.documentFormControllerService.getDocumentForm(this.serviceId, true).subscribe(
          (data) => {
            this.copyFromFormSchema = (data ? data.formSchema : this.copyFromFormSchema);
            this.isCopyFromOpen = true;
            this.copyFromFormTitle = "builder.documentForm";
          },
        );
        break;
      case "sendfile":
        this.sendFileFormControllerService.getSendFileForm(this.serviceId, true).subscribe(
          (data) => {
            this.copyFromFormSchema = (data ? data.formSchema : this.copyFromFormSchema);
            this.isCopyFromOpen = true;
            this.copyFromFormTitle = "builder.send";

          },
        );
        break;
      case "role":
        this.copyFromFormSchema = this.roleForms[ev.detail.key.slice(5)];
        this.copyFromFormTitle = ev.detail.title;
        this.isCopyFromOpen = true;
        break;
    }
  }

  public formioFormBuilderDragStarted(ev: any) {
    const component = ev.detail;
    if (this.copyFromDialog && component.options && component.options.builder && component.options.builder.isForCopy) {
      this.copyFromDialog.nativeElement.style.width = "30%";
      this.copyFromDialog.nativeElement.style.left = "auto";
    }
    this.updateTabNames(ev);
  }

  public formioFormBuilderDragEnded(ev: any) {
    const component = ev.detail;
    if (this.copyFromDialog && component.options && component.options.builder && component.options.builder.isForCopy) {
      this.copyFromDialog.nativeElement.style.width = "100%";
      this.copyFromDialog.nativeElement.style.left = "0";
      this.saveForm();
    }
  }

  public mousedown(ev: any) {
    if (ev.target.classList.contains("formio-dialog-content")) {
      this.formioDialogContent = ev.target;
      this.addMouseDownListener(ev);
    }
    if (ev.target.classList.contains("fa-cog")) {
      this.updateTabNames(ev);
    }
  }

  public mouseup(ev: any) {
    this.m_pos = null;
    document.removeEventListener("mousemove", this.resize, false);
    if (this.resizeRaf) {
      cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = undefined;
    }
    this.pendingWidth = undefined;
    this.destroyResizeOverlay();
    if (!this.formioDialogContent) {
      return;
    }
    this.formioDialogContent.classList.remove("resize-active");
  }

  public resize(e: any) {
    if (!this.formioDialogContent || this.m_pos == null) {
      return;
    }
    e.preventDefault();
    const dx = this.m_pos - e.clientX;
    this.m_pos = e.clientX;
    if (dx === 0) {
      return;
    }

    const currentWidth = this.pendingWidth ?? this.formioDialogContent.getBoundingClientRect().width;
    this.pendingWidth = Math.max(this.minDrawerWidth, currentWidth + dx);

    if (this.resizeRaf) {
      return;
    }

    this.resizeRaf = requestAnimationFrame(() => {
      if (this.formioDialogContent && this.pendingWidth != null) {
        this.formioDialogContent.style.width = `${this.pendingWidth}px`;
      }
      this.resizeRaf = undefined;
    });
  }

  public addMouseDownListener(e: any) {
    if (e.offsetX < this.borderSize) {
      this.m_pos = e.clientX;
      if (!this.formioDialogContent || this.m_pos == null) {
        return;
      }
      this.formioDialogContent.classList.add("resize-active");
      document.addEventListener("mousemove", this.resize, false);
      this.createResizeOverlay();
    }
  }

  private createResizeOverlay(): void {
    if (this.resizeOverlay) {
      return;
    }
    const overlay = document.createElement("div");
    overlay.classList.add("formio-resize-overlay");
    Object.assign(overlay.style, {
      position: "fixed",
      inset: "0",
      cursor: "col-resize",
      zIndex: "2147483647",
      background: "transparent",
      userSelect: "none",
    });
    document.body.appendChild(overlay);
    this.resizeOverlay = overlay;
  }

  private destroyResizeOverlay(): void {
    if (this.resizeOverlay?.parentNode) {
      this.resizeOverlay.parentNode.removeChild(this.resizeOverlay);
    }
    this.resizeOverlay = undefined;
  }

  public checkDuplicatedKeys() {
    this.duplicatedFields = [];
    const components = document.querySelectorAll("#element1 .component-settings-button-edit");
    components.forEach((c) => {
      const key = c.getAttribute("data-id");
      const occurences = this.allFormsFields.filter((d) => d.key === key);
      if (key && occurences.length > 1) {
        const duplicatedOccurences = this.duplicatedFields.find((f) => f.key === key);
        const component = document.querySelectorAll(`.formio-component-${key}`);
        if (duplicatedOccurences) {
          component.forEach((comp) => {
            const alreadyAdded = duplicatedOccurences.occurences.find((o) => comp === o);
            if (!alreadyAdded) {
              duplicatedOccurences.occurences.push(comp);
            }
          });
        } else {
          const tempC = [];
          component.forEach((comp) => {
            tempC.push(comp);
          });
          this.duplicatedFields.push({
            key,
            occurences: tempC,
          });
        }
      }
    });
    this.indicateFields();
  }

  public indicateFields() {
    this.duplicatedFields.forEach((k) => {
      if (k.occurences) {
        k.occurences.forEach((o: HTMLElement) => {
          const field = document.getElementById(o.id);
          const existingTooltip = field.querySelector(".duplicated-key");
          if (!existingTooltip) {
            const tooltip = document.getElementById(`duplicatedKey`);
            const newTooltip = tooltip.cloneNode(true) as HTMLElement;
            newTooltip.id = newTooltip.id + "-" + k.key;
            newTooltip.classList.remove("hidden");
            field.insertBefore(newTooltip, field.firstChild);
          }
        });
      }
    });
  }

  private getAllformFields() {
    if (!this.allFormsFields || !this.allFormsFields.length) {
      this.formControllerService.getFlattenFormFields(this.serviceId).subscribe(
        (data) => {
          this.allFormsFields = data;
          this.addListenersOnTabs();
          this.checkDuplicatedKeys();
        },
      );
    } else {
      this.checkDuplicatedKeys();
    }
  }

  public addListenersOnTabs() {
    const tabs = document.querySelectorAll("#element1 .nav-item");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        this.checkDuplicatedKeys();
      }, false);
    });
  }

  public copyComponent() {
    if (this.formioInstance) {
      this.formioInstance.copyComponent(this.formioInstance);
    }
  }

  public ngOnInit() {
    if (!this.translationsLoaded && this.translate.translations) {
      this.translationsPresent({
        lang: this.store.state.common.lang,
        translations: this.translate.translations[this.store.state.common.lang],
      });
    }
    this.genericDeterminantUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/generaldeterminant";
    this.editGridValidationUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/grid-validation";
    this.determinantUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiodeterminant";
    this.determinantTriggersUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/newFormiodeterminant";
    this.relatedDeterminantUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/relatedDeterminant";
    this.triggersUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/botstriggers";
    this.formulaUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formioformula";
    this.tabTabsUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiotabs";
    this.tabTranslateUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiotranslate";
    this.dynamicValidationUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiovalidation/dynamic";
    this.blacklistValidationUrl = environment.OAUTH_REDIRECT_URL + "/" + this.serviceId + "/formiovalidation/blacklist";

    this.serviceControllerService.getService(this.serviceId).subscribe((data: Service) => {
      this.service = data;
      this.loadServiceRegistrations();
      this.defineCustomFieldEditWindow();
      if (this.service && this.service.serviceJsonProperties && this.service.serviceJsonProperties.enableDuplicatedKeysVerification) {
        this.addListenersOnTabs();
        this.getAllformFields();
      }
    });

    if (!Object.keys(this.determinantMapById).length) {
      this.getServiceDeterminantKeyName();
    }

    this.formioCKBlur = this.formioCKBlur.bind(this);
    this.formioEditComponent = this.formioEditComponent.bind(this);
    this.formioDeleteComponent = this.formioDeleteComponent.bind(this);
    this.openFormForCopy = this.openFormForCopy.bind(this);
    this.formioFormBuilderDragStarted = this.formioFormBuilderDragStarted.bind(this);
    this.formioFormBuilderDragEnded = this.formioFormBuilderDragEnded.bind(this);
    this.mousedown = this.mousedown.bind(this);
    this.mouseup = this.mouseup.bind(this);

    document.addEventListener("formioCKBlur", this.formioCKBlur);
    document.addEventListener("formioEditComponent", this.formioEditComponent);
    document.addEventListener("formioDeleteComponent", this.formioDeleteComponent);
    document.addEventListener("openFormForCopy", this.openFormForCopy);
    document.addEventListener("formioFormBuilderDragStarted", this.formioFormBuilderDragStarted);
    document.addEventListener("formioFormBuilderDragEnded", this.formioFormBuilderDragEnded);
    document.addEventListener("mousedown", this.mousedown);
    document.addEventListener("mouseup", this.mouseup);

    // this.options.builder.catalogs.loadOnDemand = this.loadCatalogs.bind(this);
    this.options.builder.allFields.loadOnDemand = this.loadAllFields.bind(this);
    this.options.BASE_URL = environment.BASE_URL;
    this.options.serviceId = this.serviceId;
    this.options.pasteWithTransformationEnabled = this.pasteWithTransformationEnabled;
    this.options.pasteWithTransformationIntoCertificate = this.pasteWithTransformationIntoCertificate;
    this.options.methods = {
      generateFormDeterminantOutOfOtherRelation: this.generateFormDeterminantOutOfOtherRelation.bind(this),
      generateDeterminantForNewKeys: this.generateDeterminantForNewKeys.bind(this),
      findAllPossibleDeterminantIds: FormioDeterminantBuilderComponent.findAllPossibleDeterminantIds,
    };
    // this.options.builder.systemTags.loadOnDemand = this.loadAllTags.bind(this);
  }

  public checkDebugMode() {
    this.store.debugMode$.subscribe((mode) => {
      this.debugMode = mode;
      if (this.debugMode) {
        this.fetchDebugErrors();
      } else {
        this.clearHighlights();
      }
    });
  }

  private fetchDebugErrors() {
    const cachedResults = this.store.state.common.dryRunResults.get(this.serviceId);
    if (cachedResults) {
      this.processDebugErrors(cachedResults);
    } else {
      this.serviceControllerService.recoverOrphanConfig(this.serviceId).subscribe((errors) => {
        this.store.state.common.dryRunResults.set(this.serviceId, errors);
        this.processDebugErrors(errors);
      });
    }
  }

  private processDebugErrors(errors: RecoverOrphanConfig[]) {
    const parentType = this.getParentTypeFromFormType(this.formType);
    console.log(`DebugErrors: Processing for formType='${this.formType}', parentType='${parentType}', roleId='${this.roleId}'`);

    this.debugErrors = errors.filter(error => {
      if (this.roleId) {
        return error.parentType === 'USERROLE' && error.parentId === this.roleId;
      } else {
        return error.parentType === parentType;
      }
    });
    console.log(`DebugErrors: Found ${this.debugErrors.length} errors for this form out of ${errors.length} total.`);

    if (this.builderReady) {
      this.highlightErrors();
    }
  }

  private highlightErrors() {
    if (!this.formioInstance || !this.debugErrors.length) { return; }
    const formioSchema = _.cloneDeep(this.formioInstance.schema);
    this.debugErrors.forEach(error => {
      if (!this.focusCompKey || error.componentKey === this.focusCompKey) {
        this.showComponent(error.componentKey, false, formioSchema);
        const comp = this.formioInstance.getComponent(error.componentKey);
        if (comp && comp.element) {
          comp.element.classList.add('comp-has-error');
        } else {
          console.warn(`DebugErrors: Could not find component for error:`, error);
        }
      }
    });
  }

  private clearHighlights() {
    if (!this.formioInstance) { return; }
    // Remove focused-hashtag from all elements that might have it
    let elements = this.formioInstance.element.querySelectorAll('.focused-hashtag');
    elements.forEach(el => el.classList.remove('focused-hashtag'));
    elements = this.formioInstance.element.querySelectorAll('.comp-has-error');
    elements.forEach(el => el.classList.remove('comp-has-error'));
  }

  private getParentTypeFromFormType(formType: string): string {
    switch (formType) {
      case 'applicantform': return 'FORM';
      case 'guide':
      case 'guide-form': return 'GUIDEFORM';
      case 'document-form': return 'DOCUMENT';
      case 'payment': return 'PAYMENT';
      case 'sendfile': return 'SENDPAGE';
      default: return '';
    }
  }

  public ngOnChanges(_changes: SimpleChanges): void {
    if (this.service && this.service.serviceJsonProperties && this.service.serviceJsonProperties.enableDuplicatedKeysVerification) {
      this.addListenersOnTabs();
      this.getAllformFields();
    }
    this.getOptions();
    if (_changes.focusCompKey && this.focusCompKey && this.builderReady && this.formioInstance) {
      this.clearHighlights();
      this.showComponent(this.focusCompKey, false);
      const comp = this.formioInstance.getComponent(this.focusCompKey);
      if (comp && comp.element) {
        comp.element.classList.add("comp-has-error");
        comp.element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  public ngOnDestroy() {
    this.messageBridge.removeAllListeners("FormBuilder");
    this.messageBridge.removeAllListeners("FormulaBuilder");
    document.removeEventListener("formioCKBlur", this.formioCKBlur);
    document.removeEventListener("formioEditComponent", this.formioEditComponent);
    document.removeEventListener("formioDeleteComponent", this.formioDeleteComponent);
    document.removeEventListener("openFormForCopy", this.openFormForCopy);
    document.removeEventListener("formioFormBuilderDragStarted", this.formioFormBuilderDragStarted);
    document.removeEventListener("formioFormBuilderDragEnded", this.formioFormBuilderDragEnded);
    document.removeEventListener("mouseup", this.mouseup);
    document.removeEventListener("mousedown", this.mousedown);
    document.removeEventListener("mousemove", this.resize);
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public getOptions(): void {
    if (!this.requiremntsLoaded && !this.requiremntsLoading) {
      this.loadRequirements();
    }
    // if (this.roleId && !this.treasuryPanelLoaded && !this.treasuryPanelLoading) {
    //   this.loadTreasuryRolePanel();
    // }
    if (!this.paymentsTableLoaded && !this.paymentsTableLoading) {
      this.loadPaymentsTable();
    }
    if (!this.paymentsProvidersLoaded && !this.paymentsProvidersLoading) {
      this.loadPaymentsProviders();
    }
    if (!this.myApplicationsLoaded && !this.myApplicationsLoading) {
      this.loadMyApplications();
    }
    this.options.formName = this.formName;
    this.options.i18n = this.tranlsationData;
    this.options.language = this.translate.currentLang || this.translate.defaultLang;
    this.options.getToken = this.getToken.bind(this);
    this.options.BASE_URL = environment.BASE_URL;
    this.options.noComponentPreview = true;
    this.options.editForm.BASE_URL = this.options.BASE_URL;
    this.options.editForm.getToken = this.options.getToken;
    this.options.defaultComponents = {
      number: {
        delimiter: true,
        decimalLimit: 3,
      },
      file: {
        multiple: true,
      },
      columns: {
        label: "",
      },
      dropdown: {
        leftIcon: "fa-solid fa-ellipsis-vertical",
        label: null,
      },
      // eslint-disable-next-line
      textarea: {
        validate: {
          minLength: 0,
          maxLength: 5000,
        },
      },
      button: {
        dataGridLabel: true,
      },
      editgrid: {
        emptyRowFeedbackMessage: 'Your list is empty<br>\nStart adding and editing items',
      },
      "*": {
        allowCalculateOverride: false,
      },
    };
    if (this.formType === "certificate-form") {
      this.options.ckConfig.fontSize.options = [10, "default", 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40];
    }
  }

  public getOptionsForCopy(): void {
    this.optionsForCopy = JSON.parse(JSON.stringify(this.options));
    this.optionsForCopy.formName = this.formName;

    if (this.optionsForCopy && this.optionsForCopy.builder) {
      this.optionsForCopy.builder.isForCopy = true;
      this.optionsForCopy.builder.noSideBar = true;
      this.optionsForCopy.builder.noToolbar = true;
      this.optionsForCopy.builder.allFields = {};
      this.optionsForCopy.builder.systemTags = {};
      if (this.mainFormBuilder && this.mainFormBuilder.formio) {
        this.optionsForCopy.externalDragables = this.mainFormBuilder.formio.dragContainers;
      }
    }
  }

  private loadCatalogs(cb: any) {
    const components = { components: {} };
    this.formioController.getFormCatalogs().subscribe(
      (data) => {
        const list = data as ClassificationType[];
        if (list.length > 0) {
          list.forEach((item) => {
            components.components[item.name] = {
              title: item.name,
              key: FormUtils.generateGuideIdFromTitle(item.name),
              icon: "fa fa-server",
              schema: {
                label: item.name,
                type: "select",
                catalog: item.id,
                dataSrc: "catalog",
                input: true,
                version: "201905",
              },
            };
          });
        }
      },
      (error) => this.showErrorMessageWithTitle("Error when loading Catalogs", error),
      () => cb(components),
    );
  }

  private loadRequirements() {
    this.requiremntsLoading = true;
    this.formioController.getFormRequirements(this.serviceId).subscribe(
      (data) => {
        const requirement = {
          title: "Requirements",
          key: data.key,
          icon: "fa-light fa-files",
          builderInfo: {
            title: "Requirements",
            key: data.key,
            icon: "fa-light fa-files",
            group: "custom",
            weight: 0,
            schema: {
              label: "Requirements",
              type: "columns",
              key: data.key,
              input: true,
              columns: data.columns,
            },
          },
        };
        Formio.registerComponent(data.key, requirement);
        this.requiremntsLoaded = true;
        this.requiremntsLoading = false;
      },
      () => {
        this.requiremntsLoaded = true;
        this.requiremntsLoading = false;
      },
    );
  }

  private loadPaymentsTable() {
    this.paymentsTableLoading = true;
    this.paymentFormControllerService.getFormPayments(this.serviceId, this.formType).subscribe(
      (data) => {
        const cost = {
          key: data.key,
          icon: "fa-light fa-money-check-dollar",
          title: "Payments table",
          builderInfo: {
            title: "Payments table",
            key: data.key,
            icon: "fa-light fa-money-check-dollar",
            group: "custom",
            weight: 0,
            schema: {
              type: "panel",
              label: "Fees",
              title: "Fees",
              key: data.key,
              input: true,
              components: data.components,
              icon: "fa-light fa-money-check-dollar",
              group: "custom",
              customClasses: ["payment-form-component"],
              weight: 0,
              schema: {
                type: "panel",
                label: "Fees",
                title: "Fees",
                key: data.key,
                input: true,
                components: data.components,
              },
            },
          },
        };
        Formio.registerComponent(data.key, cost);
        this.paymentsTableLoaded = true;
        this.paymentsTableLoading = false;
      },
      () => {
        this.paymentsTableLoaded = true;
        this.paymentsTableLoading = false;
      },
    );
  }

  private loadPaymentsProviders() {
    this.paymentsProvidersLoading = true;
    this.paymentFormControllerService.getFormPaymentProviders(this.serviceId).subscribe(
      (data) => {
        const cost = {
          key: data.key,
          icon: "fa-light fa-credit-card",
          title: "Payment providers",
          builderInfo: {
            key: data.key,
            icon: "fa-light fa-credit-card",
            group: "custom",
            customClasses: ["payment-providers-component"],
            weight: 0,
            title: "Payment providers",
            schema: {
              type: "panel",
              label: "Payments",
              title: "Payments",
              customClasses: ["payment-providers-component"],
              key: data.key,
              input: true,
              components: data.components,
            },
          },
        };
        Formio.registerComponent(data.key, cost);
        this.paymentsProvidersLoaded = true;
        this.paymentsProvidersLoading = false;
      },
      () => {
        this.paymentsProvidersLoaded = true;
        this.paymentsProvidersLoading = false;
      },
    );
  }

  private loadMyApplications() {
    this.myApplicationsLoading = true;
    this.formioController.getMyApplicationsComponent(this.serviceId).subscribe(
      (data) => {
        const component = {
          key: data.key,
          icon: "fa-light fa-diagram-cells",
          title: "My Applications",
          builderInfo: {
            title: "My Applications",
            icon: "fa-light fa-diagram-cells",
            group: "custom",
            weight: 60,
            schema: data,
          },
        };
        Formio.registerComponent(data.key, component);
        this.myApplicationsLoaded = true;
        this.myApplicationsLoading = false;
      },
      () => {
        this.myApplicationsLoaded = true;
        this.myApplicationsLoading = false;
      },
    );
  }

  private async generateDeterminantForNewKeys(component: any, oldToNew: { [key: string]: string }): Promise<{ [key: string]: string }> {
    return await this.formDeterminantControllerService.generateDeterminantForNewKeys(component, oldToNew).toPromise();
  }

  private async generateFormDeterminantOutOfOtherRelation(relationType: string, relationId: string): Promise<FormDeterminant> {
    return await this.formDeterminantControllerService.generateFormDeterminantOutOfRelationDeterminant(relationType, relationId).toPromise();
  }

  private loadAllFields(cb: any) {
    const components: any = { groups: {} };
    this.formControllerService.getFilteredFormFields(this.serviceId, null, false, true, false, false, false, false, false).subscribe(
      (data) => {
        if (data.length > 0) {
          data.forEach((item, index) => {
            this.updateComponentTree(item);
            item.type = "form";
            components.groups[item.key] = item;
          });
        }
      },
      (error) => this.showErrorMessageWithTitle("Error when loading All Form Fields", error),
      () => {
        cb(components);
      },
    );
  }

  private updateComponentTree(data: any) {
    data.schema = { key: data.key, type: data.type, title: data.title, label: data.label };
    data.title = data.workingTitle || data.workingLabel || data.name;
    data.icon = DataMappingHelpers.getFieldClass(data.type);
    if (data.components) {
      data.groups = {};
      data.schema.components = data.components.map((item) => {
        this.updateComponentTree(item);
        if (item.components && item.components.length > 0) {
          data.groups[item.key] = {
            title: item.workingTitle || item.workingLabel || item.name,
            key: item.key,
            name: item.name,
            type: item.type,
            schema: item.schema,
            components: item.components,
            groups: item.groups,
            disabled: item.disabled,
          };
          if (item.workingTitle || item.workingLabel) {
            data.groups[item.key].hasMoustach = true;
          }
        }
        return item.schema;
      });
      data.builderInfo = { key: data.key, type: data.type, title: data.title, schema: data.schema };
      data.builderInfo.disabled = data.disabled;
    }
  }

  private loadAllTags(cb: any) {
    const components = { components: {} };
    this.tagControllerService.getServiceTagList(this.serviceId).subscribe(
      (data) => {
        const tempTags = [];
        _.forEach(data, (d) => {
          d.name = d.name.replace("License URL", "URL");
          tempTags.push(d.name);
        });
        this.moustaches = _.union(tempTags, this.moustaches);
        this.moustaches.sort((a, b) => {
          const nameA = a.toLowerCase();
          const nameB = b.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
        _.forEach(this.moustaches, (m) => {
          components.components[m] = {
            title: m,
            key: m.replace(" ", "_"),
            icon: "fas fa-tag",
            type: "textfield",
            schema: {
              noOptions: false,
              type: "textfield",
              label: m,
              title: m,
              key: m.replace(" ", "_"),
              input: true,
            },
          };
        });
      },
      (error) => this.showErrorMessageWithTitle("Error when loading All tags", error),
      () => cb(components),
    );
  }

  private parseGroups(item: any) {
    const groups = {};
    if (item.components) {
      item.components.forEach((subItem: any) => {
        if (subItem.components) {
          const componentTitle = subItem.name;
          const componentIcon = DataMappingHelpers.getFieldClass(subItem.type);
          const subComponent = this.parseComponents(subItem, false);
          const group = this.parseGroups(subItem);
          groups[subItem.key ? subItem.key : item.key + subItem.type] = {
            title: componentTitle,
            key: subItem.key,
            name: subItem.name,
            type: subItem.type,
            icon: componentIcon,
            schema: subItem,
            components: subComponent,
            groups: group,
          };
        }
      });
    }
    return groups;
  }

  private parseComponents(item: any, isParent: boolean) {
    const components = {};
    if (item.components) {
      if (!isParent) {
        const component = this.parseComponent(item);
        components[component.key] = component;
      }
      item.components.forEach((subItem: any) => {
        const componentTitle = subItem.name;
        const componentIcon = DataMappingHelpers.getFieldClass(subItem.type);
        components[subItem.key] = {
          title: componentTitle,
          name: subItem.name,
          key: subItem.key,
          schema: subItem,
          type: subItem.type,
          icon: componentIcon,
          builderInfo: {
            title: componentTitle,
            key: subItem.key,
            icon: componentIcon,
            type: subItem.type,
            schema: subItem,
          },
        };
      });
    }
    return components;
  }

  private parseComponent(item: any) {
    const componentIcon = DataMappingHelpers.getFieldClass(item.type);
    const componentTitle = item.name;
    const comp = {
      title: componentTitle,
      key: item.key,
      schema: item,
      type: item.type,
      icon: componentIcon,
      builderInfo: {
        title: componentTitle,
        key: item.key,
        type: item.type,
        icon: componentIcon,
        schema: item,
      },
    };
    return comp;
  }

  private addCustomComponents() {
    const iSwearComponent = swearComponent.default;
    Formio.registerComponent(iSwearComponent.key, iSwearComponent);
    const printTemplateButtonComponent = printTemplateButton.default;
    Formio.registerComponent(printTemplateButtonComponent.key, printTemplateButtonComponent);

    const productList = {
      title: "Product list",
      key: "productList",
      icon: "fa-light fa-list-tree",
      useJsonEdit: true,
      builderInfo: {
        title: "Product list",
        key: "productList",
        icon: "fa-light fa-list-tree",
        group: "custom",
        weight: 100,
        schema: {
          label: "Product list",
          type: "cubanproductlist",
          key: "productList",
          skipServerSideValidation: true,
          components: [{
            class: "editgrid",
            key: "productList",
            label: "Product list",
            skipServerSideValidation: true,
            validate: {
              custom: "valid = (data[component.key] && data[component.key].length >= 1) ? true : {{ 'Please specify at least one product' | translate }}",
            },
            components: [
              {
                class: "textfield",
                key: "parentChapter",
                input: true,
                label: "Chapter",
                inputType: "select",
                type: "select",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "parentHeading",
                input: true,
                label: "Heading",
                inputType: "select",
                type: "select",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "parentSubheading",
                input: true,
                label: "Subheading",
                inputType: "select",
                type: "select",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "product",
                input: true,
                label: "Product",
                inputType: "select",
                type: "select",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "id",
                input: true,
                label: "Id",
                inputType: "text",
                type: "textfield",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "name",
                label: "Name",
                type: "textfield",
                inputType: "text",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "date",
                label: "date",
                type: "textfield",
                inputType: "text",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "type",
                input: true,
                label: "Type",
                type: "textfield",
                inputType: "text",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "operation",
                label: "Operation",
                type: "select",
                inputType: "select",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "temporality",
                label: "Temporality",
                type: "select",
                inputType: "select",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "duration",
                label: "Duration",
                type: "number",
                inputType: "number",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "donative",
                label: "Donative",
                type: "checkbox",
                inputType: "checkbox",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "exemption",
                label: "Exemption",
                type: "checkbox",
                inputType: "checkbox",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "exemptionDuration",
                label: "Exemption Duration",
                type: "number",
                inputType: "number",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "approved",
                label: "Approved",
                type: "checkbox",
                inputType: "checkbox",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "from",
                label: "Date From",
                type: "datetime",
                inputType: "date",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "to",
                label: "Date to",
                type: "datetime",
                inputType: "date",
                allowCalculateOverride: false,
              },
              {
                class: "textfield",
                key: "to118law",
                label: "Date to 118",
                type: "datetime",
                inputType: "date",
                allowCalculateOverride: false,
              },
            ],
            type: "editgrid",
            inputType: "editgrid",
          },
          ],
        },
      },
      editForm: [
        {
          key: "layout",
          ignore: true,
        },
        {
          key: "validation",
          ignore: true,
        },
        {
          key: "api",
          ignore: true,
        },
        {
          key: "conditional",
          ignore: true,
        },
        {
          key: "logic",
          ignore: true,
        },
        {
          key: "data",
          ignore: true,
        },
        {
          key: "display",
          ignore: true,
        },
      ],
    };
    Formio.registerComponent(productList.builderInfo.schema.type, productList);
    Formio.registerComponent(qrcode.default.builderInfo.schema.type, qrcode.default);
    Formio.registerComponent(barcode.default.builderInfo.schema.type, barcode.default);
    Formio.registerComponent(alert.default.key, alert.default);
    Formio.registerComponent(receipt.default.key, receipt.default);
    Formio.registerComponent(status.default.key, status.default);
    Formio.registerComponent(myList.default.key, myList.default);
    if (Boolean(environment.DIGITAL_SIGNATURE_COMPONENT_ENABLED)) {
      const DigitalSignatureComponent = FormioDigitalSignatureComponent.DigitalSignature(FormioComponents.components.button);
      Formio.registerComponent(DigitalSignatureComponent.schema().key, DigitalSignatureComponent);
    }
    const FormioNestedHtmlElementComponent = FormioNestedHtmlElement.NestedHtmlElement(FormioComponents.components.panel);
    Formio.registerComponent(FormioNestedHtmlElementComponent.schema().key, FormioNestedHtmlElementComponent);
    const FormioLeafletMapComponent = FormioLeafletMap.Class(FormioComponents.components.base);
    // Override the builderInfo icon for the Leaflet map component
    Object.defineProperty(FormioLeafletMapComponent, 'builderInfo', {
      get() {
        return {
          title: 'Map',
          group: 'advanced',
          icon: 'fa-light fa-map-location-dot',
          weight: 50,
          schema: FormioLeafletMapComponent.schema(),
        };
      },
      configurable: true
    });
    Formio.registerComponent(FormioLeafletMapComponent.type, FormioLeafletMapComponent);
    const FormioDropdownComponent = FormioDropdown.Class(FormioComponents.components.panel);
    // eslint-disable-next-line no-empty, @typescript-eslint/no-empty-function
    FormioDropdownComponent.prototype.onAnyChanged = () => { };
    // Override the builderInfo icon for the Dropdown component
    Object.defineProperty(FormioDropdownComponent, 'builderInfo', {
      get() {
        return {
          title: 'Dropdown',
          group: 'advanced',
          icon: 'fa-light fa-square-ellipsis-vertical',
          weight: 50,
          schema: FormioDropdownComponent.schema(),
        };
      },
      configurable: true
    });
    Formio.registerComponent(FormioDropdownComponent.type, FormioDropdownComponent);
    const serviceFormsComponents = serviceForms.default;
    this.rolesLoaded = false;
    this.roleController.getRolesList(this.serviceId, true).subscribe((data) => {
      if (data && data.length) {
        data.filter((role) => {
          return role.name !== "Applicant";
        }).forEach((role) => {
          if (!role.formSchema || !role.formSchema.components || !role.formSchema.components.length) {
            return;
          }
          serviceFormsComponents.push({
            title: role.name,
            key: "role-" + role.id,
            icon: "fas fa-chalkboard-teacher",
            group: "serviceforms",
            builderInfo: {
              title: role.name,
              icon: "fas fa-chalkboard-teacher",
              group: "serviceforms",
              weight: 30,
            },
          });
          this.roleForms[role.id] = role.formSchema;
        });
      }
    },
      (error) => console.error(error),
      () => {
        serviceFormsComponents.forEach((schema: any) => {

          if (this.tranlsationData[this.options.language] && this.tranlsationData[this.options.language][schema.builderInfo.title]) {
            schema.builderInfo.title = this.tranlsationData[this.options.language][schema.builderInfo.title];
          }
          let formKey = "";
          let showForm = true;
          if (!this.roleId) {
            if (this.formType === String(schema.key)) {
              showForm = false;
            }
            formKey = String(schema.key);
          } else {
            formKey = `role-${this.roleId}`;
            if (String(schema.key) === `role-${this.roleId}`) {
              showForm = false;
            }
          }

          const formElement = Formio.Components.components[schema.type] ? Formio.Components.components[schema.type].builderInfo.element : null;

          if (showForm) {
            if (formElement) {
              formElement.classList.remove("hiden");
            }
            schema.builderInfo.extraClass = "";
          } else {
            if (formElement) {
              formElement.classList.add("hiden");
            }
            schema.builderInfo.extraClass = "hidden";
          }

          Formio.registerComponent(schema.key, schema);

        });
        this.rolesLoaded = true;
      });
  }

  private defineCustomFieldEditWindow() {
    const componentNames = ["address", "button", "checkbox", "columns", "container", "content", "mycontent", "currency", "" +
      "", "datamap", "datetime", "day", "editgrid", "datagrid",
      "edittable", "email", "fieldset", "file", "form", "htmlelement", "", "hidden", "modaledit", "number", "panel", "password", "phoneNumber", "radio", "recaptcha",
      "resource", "select", "selectboxes", "signature", "survey", "table", "tabs", "tags", "textarea", "textfield", "time", "tree", "custom",
      "url", "well", "serviceforms", "alert", "receipt", "status", "myList", "myApplications", "qrcode", "barcode", "cubanproductlist", "leafletmap", "dropdown"];

    const tabDataJson = this.getTabSchema(tabData.default);
    const tabDataNumberJson = this.getTabSchema(tabDataNumber.default);
    const tabDataEditGridJson = this.getTabSchema(tabDataEditGrid.default);
    const tabDataDataGridJson = this.getTabSchema(tabDataDataGrid.default);
    const tabDataSelectJson = this.getTabSchema(tabDataSelect.default);
    const tabDataContentJson = this.getTabSchema(tabDataContent.default);
    const tabDataFileJson = this.getTabSchema(tabDataFile.default);
    const tabDataHiddenJson = this.getTabSchema(tabDataHidden.default);
    const tabDataTextFieldJson = this.getTabSchema(tabDataTextField.default);
    const tabFileFileJson = this.getTabSchema(tabFileFile.default);
    const tabDataButtonJson = this.getTabSchema(tabDataButton.default);
    const tabDataCheckboxJson = this.getTabSchema(tabDataCheckbox.default);
    const tabDataDateTimeJson = this.getTabSchema(tabDataDateTime.default);
    const tabDateDateTimeJson = this.getTabSchema(tabDateDateTime.default);
    const tabTimeDateTimeJson = this.getTabSchema(tabTimeDateTime.default);
    const tabValidationEditGridJson = this.getTabSchema(tabValidationEditGrid.default);
    const tabValidationTextfieldJson = this.getTabSchema(tabValidationTextfield.default);
    const tabValidationDayJson = this.getTabSchema(tabValidationDay.default);
    const tabGeneralJson = this.getTabSchema(tabGeneral.default);
    const tabGeneralLeafletMapJson = this.getTabSchema(tabGeneralLeafletMap.default);
    const tabGeneralDropdownJson = this.getTabSchema(tabGeneralDropdown.default);
    const tabGeneralButtonJson = this.getTabSchema(tabGeneralButton.default);
    const tabGeneralInputJson = this.getTabSchema(tabGeneralInput.default);
    const tabGeneralCheckboxJson = this.getTabSchema(tabGeneralCheckbox.default);
    const tabGeneralSelectJson = this.getTabSchema(tabGeneralSelect.default);
    const tabGeneralSelectBoxesJson = this.getTabSchema(tabGeneralSelectBoxes.default);
    const tabGeneralRadioJson = this.getTabSchema(tabGeneralRadio.default);
    const tabGeneralEditGridJson = this.getTabSchema(tabGeneralEditGrid.default);
    const tabGeneralDataGridJson = this.getTabSchema(tabGeneralDataGrid.default);
    const tabGeneralDateTimeJson = this.getTabSchema(tabGeneralDateTime.default);
    const tabGeneralPanelJson = this.getTabSchema(tabGeneralPanel.default);
    const tabGeneralTextfieldJson = this.getTabSchema(tabGeneralTextfield.default);
    const tabGeneralFileJson = this.getTabSchema(tabGeneralFile.default);
    const tabGeneralEmailJson = this.getTabSchema(tabGeneralEmail.default);
    const tabGeneralTextareaJson = this.getTabSchema(tabGeneralTextarea.default);
    const tabGeneralFieldsetJson = this.getTabSchema(tabGeneralFieldset.default);
    const tabGeneralTableJson = this.getTabSchema(tabGeneralTable.default);
    const tabGeneralTabsJson = this.getTabSchema(tabGeneralTabs.default);
    const tabGeneralColumnsJson = this.getTabSchema(tabGeneralColumns.default);
    const tabGeneralContentJson = this.getTabSchema(tabGeneralContent.default);
    const tabGeneralCurrencyJson = this.getTabSchema(tabGeneralCurrency.default);
    const tabGeneralNumberJson = this.getTabSchema(tabGeneralNumber.default);
    const tabGeneralMyContentJson = this.getTabSchema(tabGeneralMyContent.default);
    const tabGeneralAddressJson = this.getTabSchema(tabGeneralAddress.default);
    const tabGeneralDayJson = this.getTabSchema(tabGeneralDay.default);
    const tabGeneralUrlJson = this.getTabSchema(tabGeneralUrl.default);
    const tabValidationDateTimeJson = this.getTabSchema(tabValidationDateTime.default);
    const tabValidationNumberJson = this.getTabSchema(tabValidationNumber.default);
    const tabValidationCurrencyJson = this.getTabSchema(tabValidationCurrency.default);
    const tabValidationRadioJson = this.getTabSchema(tabValidationRadio.default);
    const tabValidationSelectJson = this.getTabSchema(tabValidationSelect.default);
    const tabValidationButtonJson = this.getTabSchema(tabValidationButton.default);
    const tabValidationCheckboxJson = this.getTabSchema(tabValidationCheckbox.default);
    const tabValidationTextareaJson = this.getTabSchema(tabValidationTextarea.default);
    const tabValidationTimeJson = this.getTabSchema(tabValidationTime.default);
    const tabValidationEmailJson = this.getTabSchema(tabValidationEmail.default);
    const tabValidationUrlJson = this.getTabSchema(tabValidationUrl.default);
    const tabValidationAddressJson = this.getTabSchema(tabValidationAddress.default);
    const tabValidationFileJson = this.getTabSchema(tabValidationFile.default);
    const tabValidationResourceJson = this.getTabSchema(tabValidationResource.default);
    const tabValidationDatagridJson = this.getTabSchema(tabValidationDatagrid.default);
    const tabValidationContentJson = this.getTabSchema(tabValidationContent.default);
    const tabValidationMyContentJson = this.getTabSchema(tabValidationMyContent.default);
    const tabDataRadioJson = this.getTabSchema(tabDataRadio.default);
    const tabCopyEditgridJson = this.getTabSchema(tabCopyEditgrid.default);
    const tabProviderAddressJson = this.getTabSchema(tabProviderAddress.default);
    const tabCopyDataGridJson = this.getTabSchema(tabCopyDataGrid.default);
    const tabDataLeafletMapJson = this.getTabSchema(tabDataLeafletMap.default);
    const tabTranslateJson = this.getTabSchema(tabTranslate.default);

    for (const comp of componentNames) {
      if (comp === "textfield") {
        this.options.editForm[comp] = [tabGeneralTextfieldJson, tabDataTextFieldJson, tabApi.default,
          tabValidationTextfieldJson, tabTemplate.default, tabConditional.default, tabFormula.default,
          tabLogic.default, tabDeterminant.default, tabRegistration.default, tabLayout.default, tabTriggers.default,
          tabTranslateJson];
      } else if (comp === "phoneNumber") {
        this.options.editForm[comp] = [tabGeneralTextfieldJson, tabDataJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "day") {
        this.options.editForm[comp] = [tabGeneralDayJson, tabDataJson, tabApi.default,
          tabValidationDayJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "editgrid") {
        this.options.editForm[comp] = [tabGeneralEditGridJson, tabDataEditGridJson, tabApi.default,
          tabValidationEditGridJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabCopyEditgridJson, tabTranslateJson];
      } else if (comp === "datagrid") {
        this.options.editForm[comp] = [tabGeneralDataGridJson, tabDataDataGridJson, tabApi.default,
          tabValidationDatagridJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabCopyDataGridJson, tabTranslateJson];
      } else if (comp === "panel") {
        this.options.editForm[comp] = [tabGeneralPanelJson, tabDataJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "table") {
        this.options.editForm[comp] = [tabGeneralTableJson, tabDataJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default];
      } else if (comp === "columns") {
        this.options.editForm[comp] = [tabGeneralColumnsJson, tabDataJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "select") {
        this.options.editForm[comp] = [tabGeneralSelectJson, tabDataSelectJson, tabApi.default,
          tabValidationSelectJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabFormula.default, tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson, tabTranslateJson];
      } else if (comp === "selectboxes") {
        this.options.editForm[comp] = [tabGeneralSelectBoxesJson, tabDataJson, tabApi.default,
          tabValidationSelectJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "datetime") {
        this.options.editForm[comp] = [tabGeneralDateTimeJson, tabDateDateTimeJson, tabTimeDateTimeJson, tabDataDateTimeJson, tabApi.default,
          tabValidationDateTimeJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabFormula.default, tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "number") {
        this.options.editForm[comp] = [tabGeneralNumberJson, tabDataNumberJson, tabApi.default,
          tabValidationNumberJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabFormula.default, tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "currency") {
        this.options.editForm[comp] = [tabGeneralCurrencyJson, tabDataJson, tabApi.default,
          tabValidationCurrencyJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabFormula.default, tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "mycontent") {
        this.options.editForm[comp] = [tabGeneralMyContentJson, tabDataJson, tabApi.default,
          tabValidationMyContentJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "content") {
        this.options.editForm[comp] = [tabGeneralContentJson, tabDataContentJson, tabApi.default,
          tabValidationContentJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "radio") {
        this.options.editForm[comp] = [tabGeneralRadioJson, tabDataJson, tabApi.default,
          tabValidationRadioJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "fieldset") {
        this.options.editForm[comp] = [tabGeneralFieldsetJson, tabDataJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "button") {
        this.options.editForm[comp] = [tabGeneralButtonJson, tabDataButtonJson, tabApi.default,
          tabValidationButtonJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "checkbox") {
        this.options.editForm[comp] = [tabGeneralCheckboxJson, tabApi.default,
          tabValidationCheckboxJson, tabTemplate.default, tabConditional.default, tabFormula.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabDataCheckboxJson, tabTriggers.default, tabTranslateJson];
      } else if (comp === "textarea") {
        this.options.editForm[comp] = [tabGeneralTextareaJson, tabDataTextFieldJson, tabApi.default,
          tabValidationTextareaJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabFormula.default, tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "file") {
        const filePatternComponent = tabFileFileJson.components.find((c) => c.key === "filePattern");
        if (filePatternComponent && this.service.serviceJsonProperties && this.service.serviceJsonProperties.requirementsFilePattern) {
          filePatternComponent.defaultValue = this.service.serviceJsonProperties.requirementsFilePattern.replace(/\s+/, ",");
        }
        if (this.fileLinkableWithRequirement) {
          tabDataFileJson.components.push(
            {
              type: "checkbox",
              hidden: true,
              key: "linkedWithRequirement",
              defaultValue: this.fileLinkableWithRequirement,
            },
          );
        }
        if (this.fileLinkableWithResult) {
          tabDataFileJson.components.push(
            {
              type: "checkbox",
              hidden: true,
              key: "linkedWithResult",
              defaultValue: this.fileLinkableWithResult,
            },
          );
        }
        this.options.editForm[comp] = [tabGeneralFileJson, tabDataFileJson, tabFileFileJson, tabApi.default,
          tabValidationFileJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "tabs") {
        this.options.editForm[comp] = [tabGeneralTabsJson, tabApi.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabTabs.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "time") {
        this.options.editForm[comp] = [tabGeneralJson, tabDataJson, tabApi.default,
          tabValidationTimeJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "url") {
        this.options.editForm[comp] = [tabGeneralUrlJson, tabDataJson, tabApi.default,
          tabValidationUrlJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "email") {
        this.options.editForm[comp] = [tabGeneralEmailJson, tabDataJson, tabApi.default,
          tabValidationEmailJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabFormula.default, tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "address") {
        this.options.editForm[comp] = [tabGeneralAddressJson, tabDataJson, tabProviderAddressJson, tabApi.default,
          tabValidationAddressJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "resource") {
        this.options.editForm[comp] = [tabGeneralJson, tabDataJson, tabApi.default,
          tabValidationResourceJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (["qrcode", "barcode"].includes(comp)) {
        this.options.editForm[comp] = [tabGeneralInputJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else if (comp === "leafletmap") {
        this.options.editForm[comp] = [tabGeneralLeafletMapJson, tabDataLeafletMapJson,
          tabValidationLeafletMap.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabApi.default, tabTranslateJson,
        ];
      } else if (comp === "dropdown") {
        this.options.editForm[comp] = [tabGeneralDropdownJson, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabApi.default, tabTranslateJson,
        ];
      } else if (comp === "cubanproductlist") {
        this.options.editForm[comp] = [tabGeneralInputJson];
      } else if (comp === "hidden") {
        this.options.editForm[comp] = [tabDataHiddenJson, tabDataJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      } else {
        this.options.editForm[comp] = [tabGeneralJson, tabDataJson, tabApi.default,
          tabValidation.default, tabTemplate.default, tabConditional.default, tabLogic.default, tabDeterminant.default,
          tabRegistration.default, tabLayout.default, tabTriggers.default, tabTranslateJson];
      }
    }
  }

  private saveForm() {
    const result = Helpers.validateFormSchema(this.formSchema);
    if (Array.isArray(result) && result.length > 0) {
      this.error("Please reload page!\n" + Helpers.generateValidationErrorMessages(result).join("\n"), 'Validation error');
    }
    else {
      this.saveFormSchema.emit(this.formSchema);
    }
  }

  public difference(object, base) {
    return _.transform(object, (result, value, key) => {
      if (!_.isEqual(value, base[key])) {
        result[key] = _.isObject(value) && _.isObject(base[key]) ? _.difference(value, base[key]) : value;
      }
    });
  }

  // this method is used to put linked requirement's or result's determinant on the component
  public modifyComponentsDeterminant(data, comp, event) {
    const formDeterminant = new FormDeterminant();
    formDeterminant.jsonDeterminant = JSON.parse(data.jsonDeterminants || '[{"type":"OR","items":[]}]');
    formDeterminant.key = comp.key;
    // TODO: Warning: Determinant data will be wrong, when you restore schema from history.
    return this.formDeterminantControllerService.modifyFormDeterminant(this.serviceId, formDeterminant).then((formDeterminantData) => {
      let conditions;
      if (Array.isArray(formDeterminantData.jsonDeterminant)) {
        conditions = formDeterminantData.jsonDeterminant;
      } else {
        conditions = JSON.parse(formDeterminantData.jsonDeterminant);
      }
      let determinantIds = [];
      if (Object.keys(this.determinantMapById).length) {
        determinantIds = Array.from(FormioDeterminantBuilderComponent.findAllPossibleDeterminantIds(conditions));
      } else {
        for (const group of conditions) {
          for (const item of group.items) {
            // support old style of jsonDeterminants obj structure
            determinantIds.push(item.determinantId || item.id ||
              (Array.isArray(item.items) && item.items.length > 0 &&
                (item.items[0].determinantId || item.items[1]?.determinantId || item.items[0].id || item.items[1]?.id)) || null);
          }
        }
      }
      determinantIds = determinantIds.filter((id) => {
        return id != null && (!Object.keys(this.determinantMapById).length || this.determinantMapById.hasOwnProperty(id));
      });  // get rid of possible nulls
      comp.determinantIds = determinantIds;
      event.component.component.determinantIds = determinantIds;
    });
  }

  private triggerSave() {
    this.formSchema = this.formioInstance.schema;
    this.saveForm();
  }

  public onBuilderReady(event: any) {
    this.formioInstance = event.instance;
    this.builderReady = true;
    if (this.debugMode) {
      this.highlightErrors();
    }
    if (this.formioInstance) {
      this.formioInstance.off('tabActiveChanged', this.triggerSave);
      this.formioInstance.on('tabActiveChanged', this.triggerSave);
      this.formioInstance.off('tabActiveChanged', this.triggerSave);
      this.formioInstance.on('navCollapsedChanged', this.triggerSave);
      if (this.focusCompKey) {
        this.showComponent(this.focusCompKey);
        event.instance.on("render", () => {
          const comp1 = this.formioInstance.getComponent(this.focusCompKey);
          if (comp1 && comp1.element) {
            comp1.element.classList.add("focused-hashtag");
          }
        });
      }
    }
    this.checkDebugMode();
    this.checkFormAndAddPlaceholder();
  }

  public showComponent(compKey, focus = true, preferSchema=null) {
    let comp = this.formioInstance.getComponent(compKey);
    if (!comp) {
      const formioSchema = preferSchema || _.cloneDeep(this.formioInstance.schema);
      let compSchema;
      FormioUtils.eachComponent(formioSchema.components, (eachComp) => {
        if (eachComp.key === compKey) {
          compSchema = eachComp;
          return true;
        }
      }, true, "", {});
      if (compSchema) {
        let parentCompSchema = compSchema.parent;
        const beforeCompKeys = [compSchema.key];
        while (parentCompSchema != null) {
          if (parentCompSchema.key) {
            let parentComp = this.formioInstance.getComponent(parentCompSchema.key);
            if (parentComp) {
              while (beforeCompKeys.length > 0) {
                const childKey = beforeCompKeys.shift();
                if (parentComp.component.type === "tabs") {
                  for (let i = 0; i < parentComp.component.components.length; i++) {
                    const tabItem = parentComp.component.components[i];
                    const childCompSchema = tabItem.key === childKey ? tabItem : FormioUtils.getComponent(tabItem.components, childKey);
                    if (childCompSchema) {
                      if (parentComp.currentTab !== i) {
                        parentComp.setTab(i);
                      }
                      break;
                    }
                  }
                }
                const childComp = parentComp.getComponent(childKey);
                if (childComp) {
                  parentComp = childComp;
                }
              }
              break;
            }
            beforeCompKeys.unshift(parentCompSchema.key);
          }
          parentCompSchema = parentCompSchema.parent;
        }
      }
      comp = this.formioInstance.getComponent(compKey);
    }
    if (comp && comp.element) {
      let parentComp = comp.parent;
      while (parentComp) {
        if (parentComp.collapsed) {
          parentComp.collapsed = false;
          parentComp.setCollapsed();
          if (parentComp.refreshCollapsedElement) {
            parentComp.refreshCollapsedElement();
          }
        }
        if (parentComp.element.classList.contains("minimized")) {
          parentComp.element.classList.remove("minimized");
        }
        parentComp = parentComp.parent;
      }
      if (focus) {
        comp.element.classList.add("focused-hashtag");
        comp.focus(true);
        comp.element.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }
  }

  public checkFormAndAddPlaceholder() {
    if (this.formType !== "certificate-form") {
      const container = document.querySelector("#element1");
      const plceholderContent = document.querySelector("#formPlaceholder").textContent;
      if (plceholderContent) {
        container.setAttribute('data-placeolder', plceholderContent);
      }
      if (container) {
        if (container.childElementCount < 2) {
          container.classList.add("form-placeholder");
        } else {
          container.classList.remove("form-placeholder");
        }
      }
    }
  }

  public async onChange(event: any) {
    this.checkFormAndAddPlaceholder();
    if (event.type === "deleteComponentForMoving") {
      return;
    }
    // console.log(event);
    if (this.service && this.service.serviceJsonProperties && this.service.serviceJsonProperties.enableDuplicatedKeysVerification) {
      this.addListenersOnTabs();
      this.getAllformFields();
    }
    // console.log(event);
    if (event.type === "receivedCurrentComponent") {
      const payload = [{
        channel: "FormBuilder",
        message: JSON.stringify({ event: "receivedCurrentComponent", data: event.data, serviceId: this.serviceId }),
      }];
      const iframes = document.getElementsByTagName("iframe");
      const frames = [];
      for (let i = 0; i < iframes.length; i++) {
        const iframe = iframes[i];
        if (iframe.src.startsWith(window.location.origin)) {
          frames.push(iframe.contentWindow);
        }
      }
      for (const frame of frames) {
        frame.postMessage(payload, "*");
      }
      return;
    } else if (event && event.type === "pasteComponent") {
      return this.updateRegistrations();
    } else if (event && event.type === "updateComponent" && event.component) {
      if (event.component.component) {
        if (!event.component.component.registrations) {
          event.component.component.registrations = {};
          registrationSelection.default.values.forEach((r) => {
            event.component.component.registrations[r.value] = true;
          });
          event.detail = event.component.component;
          this.updateTabNames(event);
        } else {
          registrationSelection.default.values.forEach((r) => {
            if (!(r.value in event.component.component.registrations)) {
              event.component.component.registrations[r.value] = true;
            }
          });
          for (const key in event.component.component.registrations) {
            if (!registrationSelection.default.values.find((r) => r.value === key)) {
              delete event.component.component.registrations[key];
            }
          }
          event.detail = event.component.component;
          this.updateTabNames(event);
        }
        if (event.component.isNew && event.component.component.type === "panel" && event.component.parent.type === "form" && !event.component._updatedForPrint && event.component.parent._form?.tags?.some((t) => t.startsWith("print-"))) {
          if (!event.component.component.components || !event.component.component.components.length) {
            event.component.component.title = "Page";
          }
          if (!Array.isArray(event.component.component.customClasses)) {
            event.component.component.customClasses = [];
          }
          if (!event.component.component.customClasses.includes("print-page-a4")) {
            event.component.component.customClasses.push("print-page-a4");
          }
          event.detail = event.component.component;
          event.component._updatedForPrint = true;
        }
      }
      // Sync isListingValue toggle with listing-value tag
      if (event.component?.component) {
        const comp = event.component.component;
        const orig = event.component.originalComponent;
        const listingTag = "listing-value";
        const hasTag = Array.isArray(comp.tags) && comp.tags.includes(listingTag);
        const hadTag = Array.isArray(orig?.tags) && orig.tags.includes(listingTag);

        if (comp.isListingValue !== orig?.isListingValue) {
          if (comp.isListingValue && !hasTag) {
            if (!Array.isArray(comp.tags)) {
              comp.tags = [];
            }
            comp.tags.push(listingTag);
          } else if (!comp.isListingValue && hasTag) {
            comp.tags = comp.tags.filter((t) => t !== listingTag);
          }
        } else if (hasTag !== hadTag) {
          comp.isListingValue = hasTag;
        }
      }
    }
    let saveNeeded = false;
    if (event && (event.type === "updateComponent") && event.component?.component?.type === "select") {
      if (event.detail?.catalogIds && event.detail?.catalogIds[0]) {
        const formSchema = event.form;
        event.detail.catalog = event.detail.catalogIds[0];
        event.component.component.catalog = event.detail.catalogIds[0];
        const comp = FormioUtils.getComponent(formSchema.components, event.component.component.key);
        if (comp) {
          comp.catalog = event.detail.catalogIds[0];
        }
        // TODO: Looks like bug. I do not know, why object is new.
        const compLatest = FormioUtils.getComponent(formSchema.components.components, comp.key);
        let changed = false;
        if (compLatest && compLatest !== comp) {
          for (const key of Object.keys(comp)) {
            if (_.isEqual(compLatest[key], comp[key])) {
              continue;
            }
            changed = true;
            compLatest[key] = comp[key];
          }
        }
        if (changed && event.builder) {
          event.builder.form = formSchema;
        }
      }
      // console.log("--- save or update", event);
    }
    if (event && (event.type === "saveComponent" || event.type === "deleteComponent" || event.type === "moveComponent")) {
      const formSchema = event.form;
      if (event.type === "saveComponent") {
        if (event.component?.type === "file") {
          const comp = FormioUtils.getComponent(formSchema.components, event.component.component.key);
          if (comp) {
            if (comp.linkingResult) {
              if (!comp.validate) {
                comp.validate = {};
              }
              if (!event.component.component.validate) {
                event.component.component.validate = {};
              }
              comp.validate.required = true;
              event.component.component.validate.required = true;
              if (comp.linkingResult !== event.originalComponent?.linkingResult) {
                // TODO: Warning: UploadFile link will be wrong, when you restore schema from history.
                if (event.originalComponent.linkingResult) {
                  await this.documentResultControllerService.updateLinkingFileUploadPath(event.originalComponent.linkingResult, "").toPromise();
                }
                await this.documentResultControllerService.updateLinkingFileUploadPath(comp.linkingResult, `${this.serviceId}#${this.roleId}#${comp.key}`).toPromise();
              }
            } else if (event.originalComponent?.linkingResult) {
              await this.documentResultControllerService.updateLinkingFileUploadPath(event.originalComponent.linkingResult, "").toPromise();
            }
            if (comp.linkingRequirement) {
              if (!comp.validate) {
                comp.validate = {};
              }
              if (!event.component.component.validate) {
                event.component.component.validate = {};
              }
              comp.validate.required = true;
              event.component.component.validate.required = true;
              if (comp.linkingRequirement !== event.originalComponent?.linkingRequirement) {
                // TODO: Warning: UploadFile link will be wrong, when you restore schema from history.
                if (event.originalComponent?.linkingRequirement) {
                  await this.documentRequirementControllerService.updateLinkingFileUploadPath(event.originalComponent.linkingRequirement, "").toPromise();
                }
                let formSection = SidenavComponent.formatForm(this.formName.toUpperCase());
                if (this.roleId) {
                  formSection = this.roleId;
                } // we are dealing with partb applicant role, routing works by id
                const newValue = `${this.serviceId}#${formSection}#${comp.key}`;
                await this.documentRequirementControllerService.updateLinkingFileUploadPath(comp.linkingRequirement, newValue).toPromise();
              }
            } else if (event.originalComponent?.linkingRequirement) {
              await this.documentRequirementControllerService.updateLinkingFileUploadPath(event.originalComponent.linkingRequirement, "").toPromise();
            }
            // TODO: Looks like bug. I do not know, why object is new.
            const compLatest = FormioUtils.getComponent(formSchema.components, comp.key);
            let changed = false;
            if (compLatest && compLatest !== comp) {
              for (const key of Object.keys(comp)) {
                if (_.isEqual(compLatest[key], comp[key])) {
                  continue;
                }
                changed = true;
                compLatest[key] = comp[key];
              }
            }
            if (changed && event.builder) {
              event.builder.form = formSchema;
            }
          }
        }
        // event.detail = event.component.component;
        // this.updateTabNames(event);

      } else if (event.type === "deleteComponent") {
        const linkingResultIds = [];
        const linkingRequirementIds = [];
        if (event.component?.component?.linkingResult) {
          linkingResultIds.push(event.component.component.linkingResult);
        }
        if (event.component?.component?.linkingRequirement) {
          linkingRequirementIds.push(event.component.component.linkingRequirement);
        }
        const subComponents = event.component?.component?.components || event.component?.component?.columns || event.component?.component?.rows;
        if (Array.isArray(subComponents)) {
          FormioUtils.eachComponent(event.component.component.components || event.component.component.columns || event.component.component.rows || [], (childComp) => {
            if (childComp.linkingResult) {
              linkingResultIds.push(childComp.linkingResult);
            }
            if (childComp.linkingRequirement) {
              linkingRequirementIds.push(childComp.linkingRequirement);
            }
          });
        }
        for (const linkingResultId of linkingResultIds) {
          await this.documentResultControllerService.updateLinkingFileUploadPath(linkingResultId, "").toPromise();
        }
        for (const linkingRequirementId of linkingRequirementIds) {
          await this.documentRequirementControllerService.updateLinkingFileUploadPath(linkingRequirementId, "").toPromise();
        }
      }
      this.formSchema = formSchema;
      saveNeeded = true;
    }
    if (event && (event.type === "updateComponent") && !event.component.isNew && event.component?.component) {
      const updatedRegistrations = this.difference(event.component.component.registrations, event.component.originalComponent.registrations);
      this.updateThirdState(event.component, updatedRegistrations);
    } else if (event && (event.type === "saveComponent") && !event.component.isNew &&
      (event.component?.component && event.component.info && event.component.info.component && event.component.info.component.registrations)) {
      const updatedRegistrations = this.difference(event.component.component.registrations, event.component.originalComponent?.registrations);
      this.propagateRegistrationChangeToFamily(event.component, updatedRegistrations, true, true);
      Object.assign(event.component.originalComponent, event.component.component);

    }
    if (saveNeeded) {
      this.saveForm();
    }
    if (event && event.type === "validationErrors") {
      this.error(event.errors.map((e) => e.message).join("\n"), "Formio builder validation errors");
    }
    if (event && event.type === "notify") {
      this.responseSuccessful(event.message);
    }

  }

  public childrenRegistrationsSame(comp: any, ancestor: any): void {
    FormioUtils.eachComponent([comp], (component) => {
      Object.keys(ancestor.component.registrations).forEach((key) => {
        if (component.registrations && component.registrations[key] !== ancestor.component?.registrations[key]) {
          // console.log('key', key, 'is different on component ', component.key, component.registrations[key], ancestor.component.registrations[key]);
          document.querySelector(`input[value="${key}"]`)?.classList.add("third-state");
        }
      });
    }, true);
  }

  public updateThirdState(component: any, updateRegistration: any) {
    if (!Object.keys(updateRegistration).length) {
      // here we should check if we should remove or apply the third state
      const formComponent = FormioUtils.getComponent(this.formSchema.components,
        component.component.key, true);
      if (formComponent) {
        this.childrenRegistrationsSame(formComponent, component);
      }
    } else {
      Object.keys(component.component.registrations)
        .filter((key) => Object.keys(updateRegistration).includes(key))
        .forEach((key) => document.querySelector(`input[value="${key}"]`)?.classList.remove("third-state"));
    }
  }

  public propagateRegistrationChangeToComponent(component: any, updateRegistration: any) {
    if (component.component.registrations && Object.keys(component.component.registrations) && Object.keys(updateRegistration)) {
      const before = {};
      Object.keys(updateRegistration).forEach((key) => {
        before[key] = component.component.registrations[key];
      });
      component.component.registrations = { ...component.component.registrations, ...updateRegistration };
      let changed = false;
      Object.keys(updateRegistration).forEach((key) => {
        if (before[key] !== component.component.registrations[key]) {
          changed = true;
          // console.log('component', component.component.key, 'changed registration key' + key + ', from: ', before[key], ' to: ', component.component.registrations[key] );
        }
      });
      if (changed) {
        const compSchema = FormioUtils.getComponent(this.formSchema.components, component.component.key, true);
        if (compSchema) {
          Object.assign(compSchema.registrations, component.component.registrations);
        }
      }
    }
  }

  public propagateRegistrationChangeToFamily(component: any, updateRegistration: any, lookDown: boolean, lookUp: boolean): void {

    if (lookDown) {
      FormioUtils.eachComponent([component], (child) => {
        this.propagateRegistrationChangeToComponent(child, updateRegistration);
      }, true);
    } else {
      this.propagateRegistrationChangeToComponent(component, updateRegistration);
    }

    let parent = component.parent;
    if (!parent) { return; }
    if (parent.type === "form") { return; }
    if (parent instanceof FormioComponents.components.column) {
      // column itself is behaviourless layout component
      // we skip it and move on to columns component
      parent = parent.parent;
    }
    // propagate selection to parent
    if (lookUp) {
      const shouldUpdateParent = [];
      Object.keys(updateRegistration).forEach((key) => {
        const newValue = updateRegistration[key];
        const parentValue = parent.component.registrations[key];
        if (newValue) {
          // when value is true then all ancestors have to be true
          this.propagateRegistrationChangeToFamily(parent, updateRegistration, false, lookUp);
        } else {
          if (parentValue !== newValue) {
            FormioUtils.eachComponent([parent], (child) => {
              if (child.component.key === parent.component.key) { return; }
              shouldUpdateParent.push(child.component.registrations[key] === newValue);
            }, true);
            if (shouldUpdateParent.length && shouldUpdateParent.every((a) => a)) {
              this.propagateRegistrationChangeToFamily(parent, updateRegistration, false, lookUp);
            }
          }
        }
      });
    }
  }

  private deleteLinksFromRegistrationDocuments(component): void {
    if (component.linkingResult) {
      this.documentResultControllerService.updateLinkingFileUploadPath(component.linkingResult, "")
        .subscribe((error) => this.showErrorMessage(error));
    }
    if (component.linkingRequirement) {
      this.documentRequirementControllerService.updateLinkingFileUploadPath(component.linkingRequirement, "")
        .subscribe((error) => this.showErrorMessage(error));
    }
  }

  public findComponent(schema: any, key: string) {
    if (schema.key === key) { return schema; }
    let comp = null;
    if (schema.components) {
      schema.components.some((component) => {
        comp = this.findComponent(component, key);
        if (comp) { return true; }
      });
    } else if (schema.columns) {
      schema.columns.some((component) => {
        comp = this.findComponent(component, key);
        if (comp) { return true; }
      });
    } else if (Array.isArray(schema.rows)) {
      schema.rows.some((component) => {
        comp = this.findComponent(component, key);
        if (comp) { return true; }
      });
    }
    return comp;
  }

  public deleteComponentActions(item: any): void {
    const compSchema = FormioUtils.getComponent(this.formSchema.components, item.key, true);
    const result = Helpers.validateFormSchema(this.formSchema);
    if (Array.isArray(result)) {
      for (const r of result) {
        if (r.key === item.key && item.code === 'DUPLICATE_KEY') {
          return;
        }
      }
    }
    if (!compSchema) {
      return;
    }
    if (item) {
      if (item.components) {
        item.components.forEach((component) => {
          this.deleteComponentActions(component);
        });
      } else if (item.columns) {
        item.columns.forEach((component) => {
          this.deleteComponentActions(component);
        });
      } else if (Array.isArray(item.rows)) {
        item.rows.forEach((component) => {
          this.deleteComponentActions(component);
        });
      }
      // we do not want to delete related field actions / formulas / determinants
      // in case item does not originate from current form
      // this check is needed to be done here again due to the fact that parent
      // originating from the form but child being taken from some other form
      if (item.key && item.key.toLowerCase().startsWith(this.formName.replace(" ", "").toLowerCase())) {
        this.deleteLinksFromRegistrationDocuments(item);
        this.formController.deleteComponent(this.serviceId, item.key).subscribe(
          (error) => this.showErrorMessage(error),
        );
      }
    }
  }

  public static changeAuthPlaceholder(newValue, obj): void {
    for (const [k, v] of Object.entries(obj)) {
      if ((k === "value" || k === "$authorization") && v === "$authorization") {
        obj[k] = newValue;
      } else if (typeof v === "object") {
        MyFormioComponent.changeAuthPlaceholder(newValue, v);
      }
    }
  }

  private async getToken() {
    return "Bearer " + await this.authService.getToken();
  }

  private getTabSchema(defaultSchema: any): any {
    let tabDataString = JSON.stringify(defaultSchema);
    tabDataString = tabDataString.split("$serviceId").join(this.serviceId);
    tabDataString = tabDataString.split("$formName").join(this.formName);
    tabDataString = tabDataString.split("$formId").join(this.formName);
    tabDataString = tabDataString.split("$formType").join(this.formType);
    if (this.roleId) {
      // partb role form
      tabDataString = tabDataString.split("$linkingPath").join(this.roleId);
    } else {
      tabDataString = tabDataString.split("$linkingPath")
        .join(SidenavComponent.formatForm(this.formName.toUpperCase()));
    }

    tabDataString = tabDataString.split("$baseUrl").join(this.baseUrl);
    tabDataString = tabDataString.split("$restheartUrl").join(this.restheartUrl);

    const schema = JSON.parse(tabDataString);
    MyFormioComponent.changeAuthPlaceholder(this.getToken.bind(this), schema);
    return schema;
  }

  private loadServiceRegistrations() {
    tabRegistration.default.components = [];
    this.registrationService.getRegistrationsList(this.serviceId).subscribe(
      (data) => {
        const values = [];
        (data as Registration[]).forEach((item) => {
          values.push({
            label: item.name,
            value: item.id,
          });
        });
        registrationSelection.default.values = values;
        tabRegistration.default.components.push(registrationSelection.default);
        this.updateRegistrations();
      },
      (error) => {
        this.showErrorMessage(error);
      },
    );
  }

  private updateRegistrations() {
    this.needsSaving = false;
    if (this.formSchema && this.formSchema.components) {
      this.formSchema.components.forEach((component) => {
        this.checkComponents(component);
      });
    }
    if (this.needsSaving) {
      this.saveForm();
    }
  }

  private checkComponents(component: any) {
    if (!component.registrations) {
      component.registrations = {};
    }
    registrationSelection.default.values.forEach((r) => {
      if (!component.registrations.hasOwnProperty(r.value)) {
        component.registrations[r.value] = true;
        this.needsSaving = true;
      }
    });
    if (Array.isArray(component.components)) {
      component.components.forEach((comp) => {
        this.checkComponents(comp);
      });
    }
    if (Array.isArray(component.rows)) {
      component.rows.forEach((row) => {
        row.forEach((r) => {
          if (Array.isArray(r.components)) {
            r.components.forEach((comp) => {
              this.checkComponents(comp);
            });
          }
        });
      });
    }
    if (Array.isArray(component.cols)) {
      component.cols.forEach((col) => {
        if (Array.isArray(col.components)) {
          col.components.forEach((comp) => {
            this.checkComponents(comp);
          });
        }
      });
    }
    if (Array.isArray(component.columns)) {
      component.columns.forEach((col) => {
        if (Array.isArray(col.components)) {
          col.components.forEach((comp) => {
            this.checkComponents(comp);
          });
        }
      });
    }
  }

  private updateTabNames(ev: any) {
    if (!ev.detail) {
      return;
    }
    const compare = ev.detail.component || ev.detail;
    const nrOfActions = Array.isArray(compare.actionRowIds) && compare.actionRowIds.length || 0;
    let nrOfRegistrations = 0;
    const nrOfFormulas = Array.isArray(compare.formulaRowIds) && compare.formulaRowIds.length || 0;
    const nrOfTabs = Array.isArray(compare.tabItemIds) && compare.tabItemIds.length || 1;
    const nrOfEffects = Array.isArray(compare.effectsIds) && compare.effectsIds.length || 0;
    let registrationChanged = false;
    if (compare.registrations) {
      Object.keys(compare.registrations).forEach((key) => {
        if (compare.registrations.hasOwnProperty(key)) {
          if (compare.registrations[key] === true) {
            nrOfRegistrations++;
          }
        }
        if (ev.component?.originalComponent?.registrations?.hasOwnProperty(key)) {
          if (ev.component.originalComponent.registrations[key] !== compare.registrations[key]) {
            registrationChanged = true;
          }
        }
      });
      // we need to emit this event only in case registrations has been changed
      if (registrationChanged) {
        Object.assign(ev.component.originalComponent.registrations, compare.registrations);
        this.triggerRefresh.emit({
          form: "relationChange",
          value: {
            count: nrOfRegistrations,
            changes: {
              registrations: compare.registrations,
            },
          },
        });
      }
    }

    tabDeterminant.default.label = this.translate.instant("Effects").concat(" (", nrOfEffects.toString(), ")");
    tabTriggers.default.label = this.translate.instant("Actions").concat(" (", nrOfActions.toString(), ")");
    tabRegistration.default.label = this.translate.instant("Registrations").concat(" (", nrOfRegistrations.toString(), ")");
    tabFormula.default.label = this.translate.instant("Formula").concat(" (", nrOfFormulas, ")");
    tabTabs.default.label = this.translate.instant("Tabs").concat(" (", nrOfTabs, ")");
  }

  public showFormBuilder() {
    return this.rolesLoaded && this.requiremntsLoaded && this.paymentsTableLoaded && this.paymentsProvidersLoaded
      && this.myApplicationsLoaded && (!this.roleId || this.treasuryPanelLoaded) && this.service;
  }

  public getUserLevel() {
    return "userLevelControl-" + this.store.state.common.userLevels.get(this.store.state.common.userLevels.pages.SideNavLevel);
  }

  public swithActionComponentType(item: any) {
    switch (item.type) {
      case "panel":
      case "fieldset":
      case "editgrid":
        item.components.forEach((component) => {
          this.deleteComponentActions(component);
        });
        break;
      case "table":
        item.rows.forEach((row) => {
          row.forEach((components) => {
            if (components.components.length > 0) {
              components.components.forEach((component) => {
                this.fieldsComponents.push(component);
              });
            }
          });
        });
        this.fieldsComponents.forEach((component) => {
          this.deleteComponentActions(component);
        });
        break;
      case "columns":
        item.columns.forEach((column) => {
          if (column.components.length > 0) {
            column.components.forEach((component) => {
              this.fieldsComponents.push(component);
            });
          }
        });
        this.fieldsComponents.forEach((component) => {
          this.deleteComponentActions(component);
        });
        break;
    }
  }
}
